//#region ENUM ErrorName

/**
 * ### ErrorName
 * Enum representing custom error names used in the application.
 *
 * @enum {string}
 * @description Centralizes and standardizes all application-specific error identifiers.
 *              These enum values can be used across effects, services, and reducers
 *              to ensure consistent error tracking and logging.
 *              Useful when dispatching or logging `GlobalErrorOccurrence` actions.
 *
 * @example
 * const error: ErrorName = ErrorName.GlobalError;
 */
export enum ErrorName {
  AngularFireAuthError = 'AngularFireAuthError',
  ActionFailedError = 'ActionFailedError',
  AuthenticationError = 'AuthenticationError',
  AutoOrderOpenOrderError = 'AutoOrderOpenOrderError',
  AutoOrderPreparedOrderError = 'AutoOrderPreparedOrderError',
  AuthUserNotFoundError = 'AuthUserNotFoundError',
  BarcodeScannerAccessError = 'BarcodeScannerAccessError',
  whyGlobalError = 'GlobalError',
  InvalidInputError = 'InvalidInputError',
  NetworkError = 'NetworkError',
  NotFoundError = 'NotFoundError',
  PermissionError = 'PermissionError',
  PasswordResetError = 'PasswordResetError',
  UsernameAlreadyInUseError = 'UsernameAlreadyInUseError',
  UserNotLoggedInError = 'UserNotLoggedInError',
  TypeSenseAPIDocError = 'TypeSenseAPIDocError',
}

//#endregion
